import utGlobals from "./globals";

/**
 * Return the current header configuration.
 * 
 * @see {@link setConfig} for an explanation of the object that will be returned.
 */
export default function getConfig() {
    return utGlobals.currentConfig;
}